import React, { useCallback, useState, useContext, useEffect } from "react";
import styled from "styled-components";
import TextField from "../Common/TextField";
import womanDoctor from "../../SVGs/womanDoctor.svg";
import CustomButton from "../Common/CustomButton";
import { useNavigate } from "react-router-dom";
import {
  getApiClient,
  makeStandardApiErrorHandler,
} from "../../server/get_api_client";
import RequireLogout from "../../permissions.js/RequireLogout";
import Footer from "../Common/Footer";
import Nav from "../Common/Nav";
import toast from "react-hot-toast";
import PageLoader from "../Common/PageLoader";

function ValidateUsername() {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [username, setUsername] = useState("");

  const Submit = useCallback(() => {
    setIsLoading(true);
      getApiClient()
        .ValidateUsername(username)
        .then( (res) => {
          setIsLoading(false);
          navigate("/Otp", {
            state: {
              username,
              email: res.data.email,
              forgetPassword: true,
            },
          });
        })
        .catch(
          makeStandardApiErrorHandler((error) => {
            setError("Username is not found");
            setIsLoading(false);
            // toast.error(error);
          })
        )
  }, [username, navigate, setIsLoading]);

  useEffect(() => {
    setError("");
  }, [username]);

  return (
    <>
      <PageLoader isLoading={isLoading} />
      <Nav />
      <Container>
        <InnerContainer>
          <LeftContaienr>
            <LeftContaienrBanner><Title>RESET PASSWORD</Title></LeftContaienrBanner>
            <LeftContaienrContent><Text>Please enter your username</Text>
            <FieldsContainer>
              <TextField
                title={"*Username or Email:"}
                direction={"column"}
                type={"text"}
                value={username}
                setValue={setUsername}
              />
              {error && <Error>{error}</Error>}
            </FieldsContainer>
            <ButtonContainer>
              <CustomButton handle={Submit} title="Submit" />
            </ButtonContainer></LeftContaienrContent>
            
          </LeftContaienr>
        </InnerContainer>
      </Container>
      <Footer />
    </>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 95vh;
`;
const LeftContaienr = styled.div`
  display: flex;
  flex-direction: column;
  width: 30vw;
  min-width: 300px;
    border-radius: 20px;
  gap: 2vh;
  border-radius: 20px;
  background: #ecf3fb;
  

`;
const InnerContainer = styled.div`
  padding: 100px 100px;
  min-height: 85vh;
  width: 90vw;
  border-radius: 30px;
  background-image: url(${womanDoctor});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: local;
  padding: 7%;
  
  @media screen and (max-width: 662px) {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
`;
const LeftContaienrBanner = styled.div`
display:flex;
width:auto;
background-color:#304961;
min-height:2vh;
padding:5%;
border-radius: 20px 20px 0 0;
align-items: center;
justify-content: center;
  box-shadow:0px 0px 10px #304961;


`;
const LeftContaienrContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
  width: auto;
  gap: 2vh;
  background: #ecf3fb;
  padding:2%;
  border-radius:20px;

  @media screen and (max-width: 662px) {
    gap: 20px;
    padding: 20px 10px;
  }
`;


const Title = styled.p`
  margin-bottom: 20px;
  color: var(--white);
font-family: 'Georgia';
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 90%;
  letter-spacing: 1px;
  white-space: wrap;
  text-transform: uppercase;


`;



const Text = styled.p`
  width: 80%;
  color: var(--darkBlue);

  font-family: "Museo Sans Cyrl";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 120% */
`;

const FieldsContainer = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
`;

const Error = styled.div`
  color: #b20000;
  text-align: left;
  width: 80%;
  font-family: "Museo Sans Cyrl";
  font-size: 12px;
  font-style: italic;
  font-weight: 300;
`;

export default RequireLogout(ValidateUsername);
